import { render, staticRenderFns } from "./SetCustomViewCard.vue?vue&type=template&id=4b033838&"
import script from "./SetCustomViewCard.vue?vue&type=script&lang=ts&"
export * from "./SetCustomViewCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SetCustomViewCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports